// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1WGE6","text":"SelectPayment_text__CZ34m","title":"SelectPayment_title__2l9B7","btn":"SelectPayment_btn__jbI2e"};